import { Pipe, PipeTransform } from '@angular/core';

export enum MappingType {
  Client = 'Client',
  CigpStaff = 'CIGP Staff'
}

@Pipe({
  name: 'mappingType'
})
export class MappingTypePipe implements PipeTransform {
  transform(value: keyof typeof MappingType): string {
    return getMappingTypeDisplay(value);
  }
}

export function getMappingTypeDisplay(mappingType: any): string {
  return MappingType[mappingType as keyof typeof MappingType] || mappingType;
}
